<script setup>
import { FormInput } from "@Components/Form";
import LanguageMenu from "@Components/LanguageMenu.vue";
import { useI18n } from "vue-i18n";

defineProps(["modelValue"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();
</script>

<template>
    <div class="bg-white border-b border-gray-300 dark:bg-gray-900 dark:border-gray-800">
        <div class="mx-auto max-w-7xl px-4 py-5 lg:px-8 sm:p-6">
            <div class="flex justify-between space-x-3">
                <div class="flex-1">
                    <div class="max-w-xl">
                        <FormInput v-model="modelValue.name" :label="__('Nom du projet')" :errors="modelValue.errors.get('name')" required :z="1" />
                    </div>
                </div>
                <div class="flex-none">
                    <div class="w-48">
                        <LanguageMenu v-model="modelValue.language" :z="1" :label="__('Langue')" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
